import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from '../reseller_landing/App.vue';
import en from '../reseller_landing/i18n/en.json';
import es from '../reseller_landing/i18n/es.json';
import ptBR from '../reseller_landing/i18n/pt_BR.json';
import { applyBrandTheme } from '../reseller_landing/theme';
import '../reseller_landing/application.css';

// Textos de cada página (sobre a base = home) e pacotes das versões do teste A/B
// (só as chaves que mudam), baixados sob demanda.
const PAGE_MESSAGES = import.meta.glob(
  '../reseller_landing/templates/*/i18n/*.json',
  { import: 'default' }
);
const PACK_MESSAGES = import.meta.glob(
  [
    '../reseller_landing/i18n/packs/*/*.json',
    '../reseller_landing/templates/*/i18n/packs/*/*.json',
  ],
  { import: 'default' }
);

const isObject = value =>
  value && typeof value === 'object' && !Array.isArray(value);

const deepMerge = (base, override) =>
  Object.fromEntries(
    [...new Set([...Object.keys(base), ...Object.keys(override)])].map(key => [
      key,
      isObject(base[key]) && isObject(override[key])
        ? deepMerge(base[key], override[key])
        : (override[key] ?? base[key]),
    ])
  );

const landing = window.resellerLanding;
applyBrandTheme(landing.brand.color);

const pageDir =
  landing.page === 'home'
    ? '../reseller_landing/i18n'
    : `../reseller_landing/templates/${landing.page}/i18n`;
const load = (files, path) => (files[path] ? files[path]() : {});

const localeMessages = async (locale, base) => {
  const [page, pack] = await Promise.all([
    load(PAGE_MESSAGES, `${pageDir}/${locale}.json`),
    load(
      PACK_MESSAGES,
      `${pageDir}/packs/${landing.version.messagePack}/${locale}.json`
    ),
  ]);
  return deepMerge(deepMerge(base, page), pack);
};

const bases = { en, es, pt_BR: ptBR };
// O seletor de idioma recarrega a página: bastam o idioma atual e o de reserva.
const LOCALES = [...new Set([landing.locale, 'pt_BR'])];
Promise.all(LOCALES.map(locale => localeMessages(locale, bases[locale]))).then(
  merged => {
    const i18n = createI18n({
      legacy: false,
      locale: landing.locale,
      fallbackLocale: 'pt_BR',
      messages: Object.fromEntries(
        LOCALES.map((locale, index) => [locale, merged[index]])
      ),
    });
    createApp(App, { landing }).use(i18n).mount('#app');
  }
);
